export const mapLinkSourceToSuffixTranslationKey = (status: string) => {
  const linkReasonMap = {
    user_discharged_by_cx: 'DISCHARGEDCX',
    user_discharged_by_cp: 'CLINICALDISCHARGED',
    user_transferred_by_tc: 'TRANSFTC',
    user_unlinked_by_cp_layoff: 'CPLAYOFF',
    user_not_satisfied_with_cp_suggestions: 'HELPTOCHOOSE',
    user_with_accesssibility_needs: 'ACESSIBILITY',
    user_sent_message_tc_auto_journey: 'HELPFORJOURNEY',
    user_did_not_send_message_tc_auto_journey: 'CPJOURNEYNOMESSAGE"',
    user_sent_message_tc_journey: 'TCJOURNEYMESSAGE',
    user_did_not_send_message_tc_journey: 'TCJOURNEYNOMESSAGE',
    user_did_not_selected_journey: 'DIDNOTSELECTJOURNEY',
    user_selected_cp_journey_no_booked_session: 'CPJOURNEYNOBOOKED',
    user_selected_tc_journey: 'SELECTEDTCJOURNEY',
    user_potentially_critical_not_satisfied_with_cp_suggestions:
      'CRITICALNOTSATISFIED',
  };

  return (
    `CAREMATRIXCPTC.TAGLINKSOURCE.${
      linkReasonMap[status as keyof typeof linkReasonMap]
    }` || status
  );
};

export const mapPreviousLinkToTranslationKey = (status: string) => {
  const translationMap = {
    CP: 'CAREMATRIXCPTC.TAGLINKSOURCE.CPTOOLTIP',
    TC: 'CAREMATRIXCPTC.TAGLINKSOURCE.WELLZSPECIALISTTOOLTIP',
  };
  if (!status) {
    return 'CAREMATRIXCPTC.TAGLINKSOURCE.THEFIRSTLINKTOOLTIP';
  }

  return translationMap[status as keyof typeof translationMap] || status;
};
